"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = require("immutable");

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _SettingsStickySaveFooter = _interopRequireDefault(require("settings-ui-lib/components/SettingsStickySaveFooter"));

var _RequestStatusTypes = _interopRequireWildcard(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-sdk/DoiPages/actions");

var _actions2 = require("settings-ui-sdk/DoiSettings/actions");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _selectors = require("settings-ui-sdk/DoiSettings/selectors");

var _actions3 = require("settings-ui-sdk/SiteSettings/actions");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _selectors2 = require("settings-ui-sdk/SiteSettings/selectors");

var _SaveActions = require("../../actions/SaveActions");

var _saveChangesSelectors = require("../../selectors/saveChangesSelectors");

var _UpdateDoiPages = _interopRequireDefault(require("../../stagedObjects/UpdateDoiPages"));

var _UpdateDoiSettings = _interopRequireDefault(require("../../stagedObjects/UpdateDoiSettings"));

var _UpdateEmailSiteSettings = _interopRequireDefault(require("../../stagedObjects/UpdateEmailSiteSettings"));

var _selectors3 = require("settings-ui-sdk/PortalSettings/selectors");

var _actions4 = require("settings-ui-sdk/PortalSettings/actions");

var _tracking = require("settings-ui-sdk/EmailFrequency/tracking");

var StickySaveFooterContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(StickySaveFooterContainer, _PureComponent);

  function StickySaveFooterContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, StickySaveFooterContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StickySaveFooterContainer).call(this, props));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(StickySaveFooterContainer, [{
    key: "handleCancel",
    value: function handleCancel() {
      var _this2 = this;

      var _this$props = this.props,
          anyDoiPagesChanges = _this$props.anyDoiPagesChanges,
          anyDoiSettingsChanges = _this$props.anyDoiSettingsChanges,
          anySiteSettingsChanges = _this$props.anySiteSettingsChanges,
          portalSettingsStagedChanges = _this$props.portalSettingsStagedChanges;

      if (anyDoiPagesChanges) {
        this.stageDomainDoiPages();
      }

      if (anyDoiSettingsChanges) {
        this.stageDomainDoiSettings();
      }

      if (anySiteSettingsChanges) {
        this.stageDomainSiteSettings();
      }

      if (!portalSettingsStagedChanges.isEmpty()) {
        portalSettingsStagedChanges.forEach(function (val, key) {
          _this2.props.unstagePortalSetting(key);
        });
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this3 = this;

      var _this$props2 = this.props,
          anyDoiPagesChanges = _this$props2.anyDoiPagesChanges,
          anyDoiSettingsChanges = _this$props2.anyDoiSettingsChanges,
          anySiteSettingsChanges = _this$props2.anySiteSettingsChanges,
          portalSettingsStagedChanges = _this$props2.portalSettingsStagedChanges;

      if (anySiteSettingsChanges) {
        this.props.saveStagedSiteSettingsChanges(this.props.stagedSiteSettings.toJS(), {
          selectedDomain: _constants.ALL_DOMAINS_KEY
        });
      }

      if (anyDoiSettingsChanges) {
        this.props.saveStagedDoiSettingsChanges(this.props.stagedDoiSettings.toJS());
      }

      if (anyDoiPagesChanges) {
        this.props.saveChanges();
      }

      if (!portalSettingsStagedChanges.isEmpty()) {
        portalSettingsStagedChanges.forEach(function (val, key) {
          _this3.props.stageAndSavePortalSetting(key, val);

          (0, _tracking.addSendFrequencyTracking)(key, val);
        });
      }
    }
  }, {
    key: "stageDomainSiteSettings",
    value: function stageDomainSiteSettings() {
      var domainSiteSettings = this.props.domainSiteSettings;
      this.props.stageSiteSettings(domainSiteSettings);
    }
  }, {
    key: "stageDomainDoiPages",
    value: function stageDomainDoiPages() {
      var domainDoiPages = this.props.domainDoiPages;
      this.props.stageDoiPages(domainDoiPages);
    }
  }, {
    key: "stageDomainDoiSettings",
    value: function stageDomainDoiSettings() {
      var domainDoiSettings = this.props.domainDoiSettings;
      this.props.stageDoiSettings(domainDoiSettings);
    }
  }, {
    key: "saveDisabled",
    value: function saveDisabled() {
      var _this$props3 = this.props,
          anyBlockingDoiChanges = _this$props3.anyBlockingDoiChanges,
          anyDoiPagesChanges = _this$props3.anyDoiPagesChanges,
          anyDoiSettingsChanges = _this$props3.anyDoiSettingsChanges;
      return (anyDoiPagesChanges || anyDoiSettingsChanges) && anyBlockingDoiChanges;
    }
  }, {
    key: "anyPendingRequests",
    value: function anyPendingRequests() {
      var _this$props4 = this.props,
          saveChangesRequestStatus = _this$props4.saveChangesRequestStatus,
          saveStagedDoiSettingsRequestStatus = _this$props4.saveStagedDoiSettingsRequestStatus,
          saveStagedSiteSettingsRequestStatus = _this$props4.saveStagedSiteSettingsRequestStatus;
      return [saveChangesRequestStatus, saveStagedDoiSettingsRequestStatus, saveStagedSiteSettingsRequestStatus].find(function (status) {
        return status === _RequestStatusTypes.default.PENDING;
      }) || _RequestStatusTypes.default.SUCCEEDED;
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var doiConfirmationPageBlockingSave = this.props.doiConfirmationPageBlockingSave;
      var errors = {};

      if (doiConfirmationPageBlockingSave) {
        Object.assign(errors, {
          doiConfirmationPageBlockingSave: doiConfirmationPageBlockingSave
        });
      }

      return _react.default.createElement(_UIList.default, {
        className: "m-all-0"
      }, Object.keys(errors).map(function (key) {
        return (0, _unescapedText.default)("marketing.email.errors." + key);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          anyDoiPagesChanges = _this$props5.anyDoiPagesChanges,
          anyDoiSettingsChanges = _this$props5.anyDoiSettingsChanges,
          anySiteSettingsChanges = _this$props5.anySiteSettingsChanges,
          numberOfStagedChanges = _this$props5.numberOfStagedChanges,
          portalSettingsStagedChanges = _this$props5.portalSettingsStagedChanges;
      var anyChanges = anyDoiPagesChanges || anyDoiSettingsChanges || anySiteSettingsChanges || !portalSettingsStagedChanges.isEmpty();
      var description = (0, _unescapedText.default)('marketing.email.stagedChanges', {
        count: numberOfStagedChanges
      });
      return _react.default.createElement(_SettingsStickySaveFooter.default, {
        description: description,
        onCancel: this.handleCancel,
        onSave: this.handleSave,
        saveDisabled: this.saveDisabled(),
        saveRequestStatus: this.anyPendingRequests(),
        disabledTooltip: this.renderErrors(),
        disabledTooltipProps: {
          placement: 'top right'
        },
        shouldRender: anyChanges
      });
    }
  }]);
  return StickySaveFooterContainer;
}(_react.PureComponent);

StickySaveFooterContainer.propTypes = {
  anyBlockingDoiChanges: _react.PropTypes.bool.isRequired,
  anyDoiPagesChanges: _react.PropTypes.bool.isRequired,
  anyDoiSettingsChanges: _react.PropTypes.bool.isRequired,
  anySiteSettingsChanges: _react.PropTypes.bool.isRequired,
  portalSettingsStagedChanges: _react.PropTypes.instanceOf(_immutable.Map),
  doiConfirmationPageBlockingSave: _react.PropTypes.bool.isRequired,
  domainDoiPages: _react.PropTypes.object,
  domainDoiSettings: _react.PropTypes.object,
  domainSiteSettings: _react.PropTypes.object,
  numberOfStagedChanges: _react.PropTypes.number,
  saveChanges: _react.PropTypes.func.isRequired,
  saveStagedDoiSettingsChanges: _react.PropTypes.func.isRequired,
  saveStagedSiteSettingsChanges: _react.PropTypes.func.isRequired,
  saveChangesRequestStatus: _RequestStatusTypes.RequestStatusPropType,
  saveStagedDoiSettingsRequestStatus: _RequestStatusTypes.RequestStatusPropType,
  saveStagedSiteSettingsRequestStatus: _RequestStatusTypes.RequestStatusPropType,
  stagedDoiSettings: _react.PropTypes.object.isRequired,
  stagedSiteSettings: _react.PropTypes.object.isRequired,
  stageDoiPages: _react.PropTypes.func.isRequired,
  stageDoiSettings: _react.PropTypes.func.isRequired,
  stageSiteSettings: _react.PropTypes.func.isRequired,
  stageAndSavePortalSetting: _react.PropTypes.func.isRequired,
  unstagePortalSetting: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var portalSettingsStagedChanges = (0, _selectors3.getStagedChanges)(state);
  var numberOfStagedChanges = _UpdateDoiPages.default.numberOfChanges(state) + _UpdateDoiSettings.default.numberOfChanges(state) + _UpdateEmailSiteSettings.default.numberOfChanges(state) + portalSettingsStagedChanges.size;
  return {
    doiConfirmationPageBlockingSave: (0, _saveChangesSelectors.getDoiConfirmationPageChangesAreBlocking)(state),
    anyBlockingDoiChanges: (0, _saveChangesSelectors.getDoiChangesAreBlockingSave)(state),
    anyDoiPagesChanges: _UpdateDoiPages.default.anyChanges(state),
    anyDoiSettingsChanges: _UpdateDoiSettings.default.anyChanges(state),
    anySiteSettingsChanges: _UpdateEmailSiteSettings.default.anyChanges(state),
    portalSettingsStagedChanges: portalSettingsStagedChanges,
    domainDoiPages: _UpdateDoiPages.default.getDomainObject(state),
    domainDoiSettings: _UpdateDoiSettings.default.getDomainObject(state),
    domainSiteSettings: _UpdateEmailSiteSettings.default.getDomainObject(state),
    numberOfStagedChanges: numberOfStagedChanges,
    saveChangesRequestStatus: (0, _saveChangesSelectors.getSaveChangesRequestStatus)(state),
    saveStagedDoiSettingsRequestStatus: (0, _selectors.getUpdateDoiSettingsRequestStatus)(state),
    saveStagedSiteSettingsRequestStatus: (0, _selectors2.getSaveSiteSettingsChangesRequestStatus)(state),
    stagedDoiSettings: _UpdateDoiSettings.default.getStagedObject(state),
    stagedSiteSettings: _UpdateEmailSiteSettings.default.getStagedObject(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  saveChanges: _SaveActions.saveChanges,
  saveStagedDoiPage: _actions.updateDoiPage,
  saveStagedDoiSettingsChanges: _actions2.updateDoiSettings,
  saveStagedSiteSettingsChanges: _actions3.saveStagedSiteSettingsChanges,
  stageDoiPages: _UpdateDoiPages.default.stageForEdit,
  stageDoiSettings: _UpdateDoiSettings.default.stageForEdit,
  stageSiteSettings: _UpdateEmailSiteSettings.default.stageForEdit,
  stageAndSavePortalSetting: _actions4.stageAndSavePortalSetting,
  unstagePortalSetting: _actions4.unstagePortalSetting
})(StickySaveFooterContainer);

exports.default = _default;
module.exports = exports.default;